module.exports = __webpack_public_path__ + "img/logo-twitter.f38b6a5d.svg";